/* eslint-disable*/
import {axiosInsNoEnc} from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    fileWhitelist: null,
    fileBlacklist: null,
  },
  getters: {
    getWhiteList: state => state.fileWhitelist,
    getBlackList: state => state.fileBlacklist,
  },
  mutations: {
    SET_FILE_WHITE_LIST: (state, value) => (value ? (state.fileWhitelist = value) : (state.fileWhitelist = null)),
    SET_FILE_BLACK_LIST: (state, value) => (value ? (state.fileBlacklist = value) : (state.fileBlacklist = null)),
  },
  actions: {
    uploadWhitelist({ rootState }, payload) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
        'Content-Type': 'multipart/form-data',
      }
      return new Promise((resolve, reject) => {
        axiosInsNoEnc.post('/whitelistFile', payload, { headers })
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    uploadBlacklist({ rootState }, payload) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
        'Content-Type': 'multipart/form-data',
      }
      return new Promise((resolve, reject) => {
        axiosInsNoEnc.post('/blacklistFile', payload, { headers })
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
